// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1TAN-","title":"Info_title__3T97d","links":"Info_links__3NJud","link":"Info_link__1loNF","logo":"Info_logo__3d12S"};